export default __webpack_public_path__ + "static/media/homebanner-3.ff1fe835.jpg";